import React from 'react';

const AnnouncementBanner = () => {
  const bannerItem = (
    <div className="flex items-center gap-2 text-xs sm:text-sm font-semibold whitespace-nowrap px-2">
      <span className="text-black">NeoPass is now</span>
      <span className="bg-yellow-400 text-black font-bold px-1.5 py-0.5 rounded">free</span>
      <span className="text-black">for Examly, iamneo and Cisco NetAcad</span>
    </div>
  );

  return (
    <div className="sticky top-0 z-[60] bg-white border-b border-black/10">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 h-10 sm:h-11 flex items-center">
        <div className="relative overflow-hidden w-full">
          <div className="banner-marquee">
            {[0, 1].map((sequenceIndex) => (
              <div
                key={`sequence-${sequenceIndex}`}
                className="banner-sequence"
                aria-hidden={sequenceIndex === 1}
              >
                {Array.from({ length: 3 }).map((_, itemIndex) => (
                  <div key={`banner-item-${sequenceIndex}-${itemIndex}`}>
                    {bannerItem}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
      <style>{`
        .banner-marquee {
          display: flex;
          width: max-content;
          animation: banner-marquee 60s linear infinite;
          will-change: transform;
        }
        .banner-sequence {
          display: flex;
          align-items: center;
          gap: 2rem;
        }
        @keyframes banner-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .banner-marquee {
            animation: none;
          }
        }
      `}</style>
    </div>
  );
};

export default AnnouncementBanner;
